import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface OrderEditDialogData {
  patientId: string;
  orderId: string;
}

@Component({
  selector: 'app-order-edit-dialog',
  templateUrl: './order-edit-dialog.component.html',
  styleUrls: ['./order-edit-dialog.component.css'],
})
export class OrderEditDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<OrderEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrderEditDialogData
  ) {}

  onClose(result?: { saved?: boolean }): void {
    this.dialogRef.close(!!result?.saved);
  }
}
